module.exports = __webpack_public_path__ + "static/wajax-logo-cf53d0a68bc3ea53287b58b918fff972.jpeg";